import { render, staticRenderFns } from "./Reputation.vue?vue&type=template&id=72b6c9b2&scoped=true&"
import script from "./Reputation.vue?vue&type=script&lang=js&"
export * from "./Reputation.vue?vue&type=script&lang=js&"
import style0 from "./Reputation.vue?vue&type=style&index=0&id=72b6c9b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b6c9b2",
  null
  
)

export default component.exports